module.exports = __webpack_public_path__ + "static/media/iconPayment.d412184d.svg";